const N_MAX_WORD_IMPORT_BYTES = 10 * 1024 * 1024;
const C_DOCX_MIME = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

export class WordImportConversionError extends Error {
  constructor(cCode, cMessage) {
    super(cMessage);
    this.name = "WordImportConversionError";
    this.cCode = cCode;
  }
}

export function fnIsLegacyWordDoc(oFile) {
  return /\.doc$/i.test(String(oFile?.name || ""));
}

async function fnReadConversionError(oResponse) {
  const cRaw = await oResponse.text();

  try {
    return JSON.parse(cRaw || "{}");
  } catch {
    return { message: cRaw };
  }
}

function fnBuildConversionHeaders() {
  const oHeaders = { Accept: C_DOCX_MIME };
  const cToken = localStorage.getItem("cStorageToken");
  const nCustId = sessionStorage.getItem("nCustId") || localStorage.getItem("nCustId");

  if (cToken) oHeaders.Authorization = `Bearer ${cToken}`;
  if (nCustId) oHeaders.nCustId = nCustId;

  return oHeaders;
}

/**
 * Converte somente o binario .doc selecionado antes de entrega-lo ao importador nativo do Froala.
 * O limite fica igual ao configurado no editor para que clique e arrastar/soltar tenham o mesmo contrato.
 */
export async function fnConvertLegacyWordDocToDocx(oFile) {
  if (!fnIsLegacyWordDoc(oFile)) {
    throw new WordImportConversionError("unsupported_type", "unsupported_type");
  }

  if (Number(oFile.size || 0) > N_MAX_WORD_IMPORT_BYTES) {
    throw new WordImportConversionError("too_large", "too_large");
  }

  const cConvertUrl = (process.env.REACT_APP_CONVERT_URL || "").replace(/\/+$/, "");
  if (!cConvertUrl) {
    throw new WordImportConversionError("configuration", "configuration");
  }

  const oFormData = new FormData();
  oFormData.append("file", oFile, oFile.name);

  let oResponse;
  try {
    oResponse = await fetch(`${cConvertUrl}/convert/docx`, {
      method: "POST",
      headers: fnBuildConversionHeaders(),
      body: oFormData,
      credentials: "include",
    });
  } catch {
    throw new WordImportConversionError("unavailable", "unavailable");
  }

  if (!oResponse.ok) {
    const oPayload = await fnReadConversionError(oResponse);
    throw new WordImportConversionError(
      oPayload?.code || `http_${oResponse.status}`,
      oPayload?.message || "conversion_error"
    );
  }

  const oBlob = await oResponse.blob();
  if (!oBlob.size) {
    throw new WordImportConversionError("error", "error");
  }

  return new File(
    [oBlob],
    String(oFile.name).replace(/\.doc$/i, ".docx"),
    { type: C_DOCX_MIME }
  );
}

export function fnGetWordImportConversionErrorKey(oError) {
  switch (oError?.cCode) {
    case "too_large":
      return "conversion_too_large";
    case "busy":
      return "conversion_busy";
    case "timeout":
      return "conversion_timeout";
    case "unsupported_type":
      return "conversion_invalid_type";
    case "configuration":
      return "conversion_configuration";
    case "unavailable":
      return "conversion_unavailable";
    default:
      return "conversion_error";
  }
}
